import React from "react";
import AdminAddTransaction from "../../Components/Admin/AdminAddTransaction";
import SideBar from "../../Components/Admin/SideBar";

const AdminAddTransactionPage = ()=>{
    return (
        <div className="d-flex justify-content-start">
        <div>
          <SideBar />
        </div>
        <div className="p-4" style={{ width: '100%' }}>
        <AdminAddTransaction/>
        </div>
      </div>
    )
}

export default AdminAddTransactionPage